import { render, staticRenderFns } from "./Projects.vue?vue&type=template&id=8662ab02"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8662ab02')) {
      api.createRecord('8662ab02', component.options)
    } else {
      api.reload('8662ab02', component.options)
    }
    module.hot.accept("./Projects.vue?vue&type=template&id=8662ab02", function () {
      api.rerender('8662ab02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/Projects.vue"
export default component.exports